
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45 35c0 2.21-1.79 4-4 4H7c-2.21 0-4-1.79-4-4V13c0-2.21 1.79-4 4-4h34c2.21 0 4 1.79 4 4z","fill":"#cfd8dc"}}),_c('path',{attrs:{"d":"M10.668 13C8.578 13 7 14.324 7 16.617V35h6.484C15.114 35 17 33.469 17 31.484V13z","fill":"#3f51b5"}}),_c('path',{attrs:{"d":"M22.668 13C20.578 13 19 14.324 19 16.617V35h6.484C27.114 35 29 33.469 29 31.484V13z","fill":"#e53935"}}),_c('path',{attrs:{"d":"M34.668 13C32.578 13 31 14.324 31 16.617V35h6.484C39.114 35 41 33.469 41 31.484V13z","fill":"#388e3c"}}),_c('path',{attrs:{"d":"M15.805 24.453c0 1.836-2.367 2.805-4.102 2.805-1.883 0-3.566-1.121-3.926-2.547h1.278c.148.867 1.02 1.477 1.984 1.477 1.07 0 1.836-.766 1.836-1.735v-3.308h2.93zm22.8-.413c.762 0 1.297-.763 1.297-1.52 0-.762-.664-1.422-1.425-1.422h-6.262v5.851h6.39c.864 0 1.524-.758 1.524-1.52 0-.757-.66-1.39-1.524-1.39zm-3.953-2.333h1.977c.504 0 .96.453.96.957 0 .512-.456.969-.96.969h-1.977zm2.028 4.637h-2.028v-1.93h2.028c.508 0 .965.457.965.965s-.458.965-.965.965zm-8.867-4.168c-1.168-.27-2.29-.426-2.848-.426-1.219 0-2.18 1.016-2.18 2.3 0 1.294.961 2.313 2.18 2.313.558 0 1.68-.105 2.848-.379v1.02h-4.875c-1.524 0-2.793-1.344-2.793-2.953 0-1.606 1.27-2.946 2.793-2.946h4.875z","fill":"#fafafa"}})])
          )
        }
      }
    